import FadeUp from "../components/site/FadeUp";
import { BRAND, CONTACT } from "../data/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Harbor Home Concierge respects your privacy. We collect only the information you choose to share with us — such as your name, contact details, home information, and the notes you send through our forms — and we use it solely to respond to you and provide our services.",
      "We do not sell, rent, or trade your personal information to anyone, ever. Access to your details is limited to the members of our team who need it to serve you, and it is handled under our confidentiality agreement.",
      "We may use privacy-friendly analytics to understand how our website is used so we can improve it. If you have any questions about your information or would like it removed, please contact us anytime.",
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      "These terms cover your use of the Harbor Home Concierge website. By requesting a walkthrough or submitting a form, you agree that the information you provide is accurate and that we may contact you about your request.",
      "Service pricing shown on this site reflects our current rates and is subject to a walkthrough or written quote. Weekly Home Management includes an initial three-month commitment and is billed monthly. Project services are quoted individually.",
      "We are fully insured and bonded and operate under a confidentiality agreement with every client. Specific service terms are confirmed in writing before work begins.",
    ],
  },
};

export default function Legal({ kind = "privacy" }) {
  const c = CONTENT[kind];
  return (
    <div data-testid={`legal-${kind}-page`} className="section-pad">
      <div className="container-hh max-w-3xl">
        <FadeUp>
          <p className="eyebrow">{BRAND.name}</p>
          <h1 className="mt-3 text-4xl md:text-5xl">{c.title}</h1>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-bodytext">
            {c.body.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          <p className="mt-8 text-bodytext">
            Questions? Email us at{" "}
            <a href={CONTACT.emailHref} className="font-semibold text-teal">
              {CONTACT.email}
            </a>
            .
          </p>
        </FadeUp>
      </div>
    </div>
  );
}
